// extracted by mini-css-extract-plugin
export default {"OtpInput":"OtpInput_OtpInput__b5ozO","otpInput":"OtpInput_otpInput__pmbB0"};